import apiService from '../apiService'

const apiPath = '/disbursement'

export const disbursementController = (configService) => {
	const service = apiService(configService)
	return {
		getFinserviceWithdraw: ({ startDate, endDate }) => {
			return service.get({
				url: `${apiPath}/get-finservice-withdraw?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getFinserviceWithdrawAccount: ({ startDate, endDate }) => {
			return service.get({
				url: `${apiPath}/get-finservice-withdraw-account?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getFinserviceWithdrawDetail: (uuid) => {
			return service.get({
				url: `${apiPath}/get-finservice-withdraw-detail?uuid=${uuid}`,
			})
		},
		getWithdrawDetailBill: ({ start, end, id_cus }) => {
			return service.get({
				url: `${apiPath}/get-withdraw-detail-bill?startDate=${start}&endDate=${end}&id_cus=${id_cus}`,
			})
		},
		saveFinserviceWithdraw: (params) => {
			return service.post({
				url: `${apiPath}/save-finservice-withdraw`,
				body: params,
			})
		},
		saveFinserviceWithdrawDetail: (params) => {
			return service.post({
				url: `${apiPath}/save-finservice-withdraw-detail`,
				body: params,
			})
		},
	}
}
